import React, { useState } from 'react';
import { Text, TouchableOpacity, View } from '@applane/react-core-components';
import { Table, Toast } from '../../app-components';
import vars from '../../theme/vars';
import { ROUTES } from '../../Lib/constants';
import { getUserRole, modifyDateView, shorten } from '../../Lib/helpers';
import { getUser, invoke } from '../../AppServices';

const { headings } = vars;

// Retrieve values from local storage
let storedData = JSON.parse(localStorage.getItem('appraisalGeneratedState'));
let avGen = localStorage.getItem('avGen')


const ViewOfferButton = () => {
  const [h, setH] = useState(false);

  return (
    <TouchableOpacity>
      <View
        onMouseOver={() => setH(true)}
        onFocus={() => setH(true)}
        onMouseLeave={() => setH(false)}
        style={{
          width: 110,
          borderRadius: 15,
          backgroundColor: h ? 'rgb(118,215,196)' : 'rgb(72,201,176)',
          alignItems: 'center',
          paddingTop: 5,
          paddingBottom: 5,
        }}
      >
        <Text style={{ ...headings.h8, color: '#FFF' }}>View</Text>
      </View>
    </TouchableOpacity>
  );
};

const createUri = (props) => {
  let addOnFilter = { type: 'avgen' };

  const userRole = getUserRole();
  const filters = props?.navigation?.state?.params?.filters;
  console.log('filters', filters)
  if (userRole === 'superadmin' || userRole === 'admin') {
    if (filters?.username) {
      addOnFilter = {
        ...addOnFilter,
        dealer: { username: filters.username?.value?.username },
      };
    }

    if (filters?.checkDate) {
      const { from, to } = filters?.checkDate?.value;
      addOnFilter = { ...addOnFilter, onDate: { $gte: from, $lte: to } };
    }
  } else if (userRole === 'dealer' || userRole === 'superdealer' || userRole === 'employee' || userRole === 'manager') {
    addOnFilter = { ...addOnFilter, dealer: { _id: getUser()?.dealer?._id } };
    if (filters?.checkDate) {
      const { from, to } = filters?.checkDate?.value;
      addOnFilter = { ...addOnFilter, onDate: { $gte: from, $lte: to } };
    }
  }

  return {
    query: {
      id: 'allData',
      addOnFilter,
    },
    aggregate: true,
    model: 'AppraisalResultCDK',
  };
};

const handleSpokenToCustomer = async ({ eventDispatcher, item }) => {
  const { _id, contacted } = item;

  eventDispatcher.notify('appLoader', true);

  await invoke({
    id: 'handleContactedToCustomer',
    paramValue: {
      itemId: _id,
      contacted: !contacted,
    },
  });

  eventDispatcher.notify('appLoader', false);

  const descriptionMsg = contacted
    ? 'Marked Customer Not Contacted Yet!'
    : 'Marked Customer Contacted!';

  Toast.show({
    message: 'Success',
    description: descriptionMsg,
    type: 'success',
    position: 'top',
    direction: 'left',
    duration: 3000,
  });

  eventDispatcher.notify(ROUTES.AppraisalGeneratedListReload.name);
};




const tableItems = {
  lg: {
    columns: [
      avGen ? storedData?.Appraisal && {
        header: 'Appraisal#',
        field: 'dms.repairOrderNumber',
        width: 200,
      } : {
        header: 'Appraisal#',
        field: 'dms.repairOrderNumber',
        width: 200,
      },
      avGen ? storedData?.Offers && {
        header: 'Offers ',
        type: 'text',
        width: 200,
        render: (props) => <ViewOfferButton {...props} />,
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.simpleList.name,
            params: {
              title: item?.offerList?.length === 0 ? 'No Offers' : 'Offers',
              item: item?.offerList ? item?.offerList : [],
            },
          },
        }),
      } : {
        header: 'Offers ',
        type: 'text',
        width: 200,
        render: (props) => <ViewOfferButton {...props} />,
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.simpleList.name,
            params: {
              title: item?.offerList?.length === 0 ? 'No Offers' : 'Offers',
              item: item?.offerList ? item?.offerList : [],
            },
          },
        }),
      },
      avGen ? storedData?.CustomerName && {
        header: 'Customer Name',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{shorten(item?.dms?.name, 16)}</Text>
        ),
        width: 200,
      } : {
        header: 'Customer Name',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{shorten(item?.dms?.name, 16)}</Text>
        ),
        width: 200,
      },
      avGen ? storedData?.Contacted && {
        header: 'Contacted',
        type: 'checkBox',
        field: 'contacted',
        width: 200,
        action: (props) => () => handleSpokenToCustomer(props),
      } : {
        header: 'Contacted',
        type: 'checkBox',
        field: 'contacted',
        width: 200,
        action: (props) => () => handleSpokenToCustomer(props),
      },
      avGen ? storedData?.VIN && {
        header: 'VIN',
        field: 'dms.vin',
        width: 200,
      } : {
        header: 'VIN',
        field: 'dms.vin',
        width: 200,
      },
      avGen ? storedData?.Make && {
        header: 'Make',
        field: 'dms.make',
        width: 200,
      } : {
        header: 'Make',
        field: 'dms.make',
        width: 200,
      },
      avGen ? storedData?.Model && {
        header: 'Model',
        field: 'dms.model',
        width: 200,
      } : {
        header: 'Model',
        field: 'dms.model',
        width: 200,
      },
      avGen ? storedData?.Year && {
        header: 'Year',
        field: 'dms.year',
        width: 200,
      } : {
        header: 'Year',
        field: 'dms.year',
        width: 200,
      },
      avGen ? storedData?.Mileage && {
        header: 'Mileage',
        field: 'dms.mileage',
        width: 200,
      } : {
        header: 'Mileage',
        field: 'dms.mileage',
        width: 200,
      },
      avGen ? storedData?.Generated && {
        header: 'Generated',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{modifyDateView(item?.onDate)}</Text>
        ),
        width: 200,
      } : {
        header: 'Generated',
        render: ({ item }) => (
          <Text style={{ fontSize: 16 }}>{modifyDateView(item?.onDate)}</Text>
        ),
        width: 200,
      },
      avGen ? storedData?.OriginalValue && {
        header: 'Original Value',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`$ ${item?.originalValue}`}</Text>
        ),
        width: 200,
      } : {
        header: 'Original Value',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`$ ${item?.originalValue}`}</Text>
        ),
        width: 200,
      },
      avGen ? storedData?.Spread && {
        header: 'Spread',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`${item?.spread} %`}</Text>
        ),
        width: 200,
      } : {
        header: 'Spread',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`${item?.spread} %`}</Text>
        ),
        width: 200,
      },
      avGen ? storedData?.Enhancement && {
        header: 'Enhancement',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`${item?.enhance} %`}</Text>
        ),
        width: 200,
      } : {
        header: 'Enhancement',
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{`${item?.enhance} %`}</Text>
        ),
        width: 200,
      },
      avGen ? storedData?.Range && {
        header: 'Range',
        field: 'finalRange',
        width: 200,
      } : {
        header: 'Range',
        field: 'finalRange',
        width: 200,
      },
    ],
  },
};

export default Table({
  uri: createUri,
  ...tableItems,
  reloadEvent: ROUTES.AppraisalGeneratedListReload.name,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.viewAppraisalResult.name,
      params: {
        item: { _id: item._id, type: item.type },
        showButtonsList: true,
        editable: false,
      },
    },
  }),
});
